import React from "react";
import { highlightText } from "../../util/highlightText";
import { ITopSearchQueryProps } from "../../types/suggestion-items";
import { ITelemetryData } from "../../types/telemetry";
import { sendTelemetryData } from "../../util/events/telemetry";
import { setStoredSearchQuery } from "../../util/queryStorage";
import { useNavigationContext } from "../../util/contexts";

const TopSearchQuery = (props: ITopSearchQueryProps) => {
    const { handleMouseSelect, handleMouseDeselect, handleTouched } = useNavigationContext();
    const trackingId = props.isPersonalized ? "ssw-zq-top-search" : "ssw-top-search";
    const formattedName = props.isPersonalized
        ? props.topSearchQuery.value
        : highlightText(props.topSearchQuery.value, props.searchInfo.searchTerm);

    const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        handleTouched(props.topSearchQuery.navIndex);
        if (!props.isPersonalized) recordTopSearchQueryUsed();
        setStoredSearchQuery({
            name: props.topSearchQuery.value,
            target: props.topSearchQuery.target
        });
        window.location.href = props.topSearchQuery.target;
    };

    const recordTopSearchQueryUsed = () => {
        const data: ITelemetryData = {
            correlationId: props.searchInfo.pageViewLogDataId,
            culture: props.searchInfo.culture,
            portal: props.searchInfo.portal,
            searchTerm: props.searchInfo.searchTerm,
            shortLink: "",
            suggestion: props.topSearchQuery.value,
            contentType: props.topSearchQuery.type
        };
        sendTelemetryData(data, props.searchInfo.trackingEndpoint);
    };

    return props.topSearchQuery.isHeadline ? (
        <li
            className={"top-search-query-text not-selectable"}
            key={props.topSearchQuery.navIndex}
            ref={props.setRef}
        >
            {props.topSearchQuery.value}
        </li>
    ) : (
        <li
            className={"top-search-query-item"}
            key={props.topSearchQuery.navIndex}
            ref={props.setRef}
            onMouseEnter={() => handleMouseSelect(props.topSearchQuery.navIndex)}
            onMouseLeave={handleMouseDeselect}
        >
            <a
                href={props.topSearchQuery.target}
                onClick={handleClick}
                data-testid={`${trackingId}-${props.topSearchQuery.anchorIndex}`}
                data-semantic-id={`${trackingId}-${props.topSearchQuery.anchorIndex}`}
            >
                {formattedName}
            </a>
        </li>
    );
};

export default TopSearchQuery;
